import React from 'react'
import { graphql } from 'gatsby'
import LayoutClassic from 'components/layouts/layoutClassic'
import Breadcrumb from 'components/blog/breadcrumb'
import SectionArticles from 'components/sections/sectionArticles'
import { getIconSocial } from 'utils'

function Author(props) {
  const { data } = props.data.page
  const dataFooter = props.data.footer.data
  const dataHeader = props.data.header.data
  const articles = props.data.articles.nodes

  return (
    <LayoutClassic
      title={`${data.name.text} - Qovery author`}
      description={`${data.name.text} - ${data.description.text}`}
      thumbnail={data.picture.url}
      dataFooter={dataFooter}
      dataHeader={dataHeader}
    >
      <div className="page__bg-white">
        <section className="hero-small hero--author">
          <Breadcrumb
            title={data.name.text}
            links={[
              { title: 'Blog', link: 'blog' },
              { title: 'Authors', link: 'authors' },
            ]}
            className="is-dark"
          />
          <div className="container">
            <div className="row">
              <div className="col col-md-10 col-lg-8 col--center">
                <div className="hero__title mt-3">
                  <div className="hero__title__content">
                    <h1 className="c-white mb-3">{data.name.text}</h1>
                    <p className="c-white mb-2">{data.description.text}</p>
                    <ul className="f mb-4 mb-md-0">
                      {data.linkedin.url && (
                        <li>
                          <a
                            className="link-social link-social--dark mr-2"
                            href={data.linkedin.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {getIconSocial('linkedin')}
                          </a>
                        </li>
                      )}
                      {data.twitter.url && (
                        <li>
                          <a
                            className="link-social link-social--dark"
                            href={data.twitter.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {getIconSocial('twitter')}
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="hero__title__image">
                    <img src={data.picture.url} alt={data.name.text} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {articles.length > 0 && (
          <div className="container">
            <div className="row">
              <div className="col col-md-10 col--center">
                <SectionArticles data={articles} hideLink />
              </div>
            </div>
          </div>
        )}
      </div>
    </LayoutClassic>
  )
}

export const queryHome = graphql`
  query ($uid: String) {
    header: prismicHeader {
      ...prismicHeaderFragment
    }
    page: prismicTeamcard(uid: { eq: $uid }) {
      ...prismicTeamcardFragment
    }
    articles: allPrismicArticle(
      filter: { data: { author: { uid: { eq: $uid } } } }
      sort: { fields: data___date, order: DESC }
    ) {
      nodes {
        uid
        ...prismicArticleFragment
      }
    }
    footer: prismicFooter {
      ...prismicFooterFragment
    }
  }
`

export default Author
